import * as StateTypes from 'src/state/types';
import * as Observe from 'src/util/observe';

export const UspsPickupLocationsValue = Observe.LookupStoreValue<StateTypes.UspsPickupLocationType>();
export const DefaultUspsPickupLocationsValue = Observe.Value<StateTypes.UspsPickupLocationType | null>(null);
export const UspsPickupLocationSuggestion = Observe.Value<StateTypes.UspsPickupLocationSuggestionType | null>(null);
export const SelectedLocationEmail = Observe.Value<string | null>(null);
export const SelectedLocationAddressId = Observe.Value<string | null>(null);
export const UspsPickupDateOptions = Observe.Value<number[] | null>(null);
